
import { Options, Vue } from "vue-property-decorator";

@Options({})
export default class Loader extends Vue {}
